<template>
    <div>
        <!--收起(缩小侧边栏)-->
        <div class="reduce-left-bar max-sm:hidden" v-if="leftIsReduce">
            <div class="leftbar-body">
                <div class="enlarge-btn" @click="handeleOpen">
                    <img src="@/assets/icon_enlarge.png" />
                    <div class="title-box">展开</div>
                </div>

                <div class="h-14 cursor-pointer mb-12 flex flex-row justify-between  items-center title-img">
                    <img src="@/assets/reduce_logo.png" @click="openAI(0)" />
                    <div class="title-box">返回首页</div>
                </div>
                
                <div class="new-chat title-img">
                    <div class="new-chat-text" @click="addChat()"></div>
                    <div class="title-box">新会话</div>
                </div>
                <div class="scene-list-box flex-1">
                    <div class="scene-item  title-img" 
                        :class="['icon-' + item.tool_id, {'active': item.tool.id === currentTool.id}]"

                        v-for="item in myTools" 
                        :key="item.tool_id"
                        @click="myToolClick(item)"
                    >
                        <span class="scene-icon"></span>
                        <div class="title-box">{{item.tool.name}}</div>
                    </div>
                </div>

                <div class="history-btn  title-img" @click="showSiderbar">
                    <span class="history-icon"></span>
                    <div class="title-box">历史会话</div>
                </div>
                <div class="free_user mt-1" buyVip
                    :class="userInfo && userInfo.is_vip ? 'vip_user2' : ''"
                    @click="buyVip"
                    @mouseover="hideInfoHandeler">
                        <span class="vip_info " v-if="userInfo && userInfo.is_vip">您的VIP有效期至{{userInfo.expire_date}}</span>
                </div>
                <div class="box1 mt-1 w-[32px] h-[32px]">
                    <img class="avatar" :src="userInfo && userInfo.avatar ? userInfo.avatar : headImg" @mouseover="showInfo = true" @mouseleave="hideInfo">
                    <div class="login_box" v-show="showInfo" @mouseover="showInfoHandeler" @mouseleave="hideInfo">
                        <p>ID：{{ userInfo ? userInfo.medlive_id : 0 }}</p>
                        <p class="text-[#4C5BDF]">{{userInfo ? userInfo.name : ''}}</p>
                        <p @click="goOrder">我的订单</p>
                        <div class="text-center" @click="loginOut">退出登录</div>
                    </div>
                </div>
            </div>
        </div>

        <!--展开(原样)-->
        <div class="leftbar-box max-sm:hidden" v-else>
            <div class="leftbar-body">
                <div class="reduce-btn" @click="handeleOpen">
                    <img src="@/assets/icon_reduce.png" />
                </div>
                <div class="cursor-pointer mb-12 flex flex-row justify-between  items-center">
                    <img src="@/assets/logo.png" @click="openAI(0)" />
                    <!-- <div class="header flex-1"> 
                        <div class="free_user" buyVip
                        :class="userInfo && userInfo.is_vip ? 'vip_user' : ''"
                        @click="buyVip"
                        @mouseover="hideInfoHandeler">
                            <span class="vip_info" v-if="userInfo && userInfo.is_vip">您的VIP有效期至{{userInfo.expire_date}}</span>
                        </div>

                        <div class="box1">
                            <img class="avatar" :src="userInfo && userInfo.avatar ? userInfo.avatar : headImg" @mouseover="showInfo = true" @mouseleave="hideInfo">
                            <div class="login_box" v-show="showInfo" @mouseover="showInfoHandeler" @mouseleave="hideInfo">
                                <p>ID：{{ userInfo ? userInfo.medlive_id : 0 }}</p>
                                <p class="text-[#4C5BDF]">{{userInfo ? userInfo.name : ''}}</p>
                                <p @click="goOrder">我的订单</p>
                                <div class="text-center" @click="loginOut">退出登录</div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <!-- <div class="find-scene">
                    <div class="find-scene-body">
                        <el-button :plain="true" class="find-scene-btn" v-popover:popover>发现AI场景</el-button>
                    </div>
                </div> -->
                <div class="new-chat">
                    <el-button :plain="true" class="new-chat-text" @click="addChat()">新会话</el-button>
                </div>
                <div class="scene-list-box flex-1">
                    <div class="scene-item" 
                        :class="['icon-' + item.tool_id, {'active': item.tool.id === currentTool.id}]"

                        v-for="item in myTools" 
                        :key="item.tool_id"
                        @click="myToolClick(item)"
                    >
                        <span class="scene-icon"></span>
                        <p class="scene-name">{{item.tool.name}}</p>
                    </div>
                </div>

                <div class="history-btn" @click="showSiderbar">
                    <span class="history-icon"></span>
                    <p>历史会话</p>
                </div>
                <div class="header"> 
                    <div class="box1">
                        <img class="avatar" :src="userInfo && userInfo.avatar ? userInfo.avatar : headImg" @mouseover="showInfo = true" @mouseleave="hideInfo">
                        <div class="login_box" v-show="showInfo" @mouseover="showInfoHandeler" @mouseleave="hideInfo">
                            <p>ID：{{ userInfo ? userInfo.medlive_id : 0 }}</p>
                            <p class="text-[#4C5BDF]">{{userInfo ? userInfo.name : ''}}</p>
                            <p @click="goOrder">我的订单</p>
                            <div class="text-center" @click="loginOut">退出登录</div>
                        </div>
                    </div>
                    <div class="free_user " buyVip
                    :class="userInfo && userInfo.is_vip ? 'vip_user' : ''"
                    @click="buyVip"
                    @mouseover="hideInfoHandeler">
                        <span class="vip_info" v-if="(userInfo && userInfo.is_vip)">您的VIP有效期至{{userInfo.expire_date}}</span>
                    </div>
                </div>
            </div>

            <!--浮窗-->
            <el-popover
                popper-class="h-auto !p-0 !rounded-[15px] absolute !left-[377px] z-20"
                v-model="toolsPop"
                ref="popover"
                placement="right-start"
                width="460"
                trigger="hover"
                :close-delay="500"
                :manual="true"
                >
                <div class="more-scene-body">
                    <div class="more-scene-cont" v-for="tools in toolList" :key="tools.name">
                        <h2 class="list-title">{{tools.name}}</h2>
                        <div class="tool-list">
                            <div class="tool-item"
                                :class="{'collected': item.collect == 1, 'AIChat': item.id === 1}" 
                                v-for="item in tools.tools" 
                                :key="item.id"
                                @click="toolClick(item)"
                            >
                                <!-- <span class="fixed-icon"  v-if="item.name === 'AI聊天'" ></span> -->
                                <!-- <template v-else> -->
                                    <el-tooltip
                                    class="item"
                                    effect="dark" 
                                    :content="item.collect==0 ? '收藏' : '取消收藏'" 
                                    placement="top"
                                    :disabled="item.id == 1"
                                    :enterable="false"
                                    >
                                        <span class="fixed-icon" @click.stop="toolCollect(item)"></span>
                                    </el-tooltip>
                                <!-- </template> -->
                                <p class="tool-name">{{item.name}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </el-popover>
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import Api from "@/utils/api";
import { Message } from 'element-ui';
export default {
    data() {
        return {
            is_vip: false,
            headImg: require("@/assets/avatar.png"),
            showInfo: false,
            infoTimer:null,
            currentTool:{
                id: 1,
                name: 'AI医学小助手'
            },
            // activeScene: "AI聊天",
            toolList:[],
            myTools:[],
            toolsPop: false,
            leftIsReduce: false
        };
    },
    props: {
        tabIndex: {
            default: 0
        }
    },
    computed: {
        ...mapState(["userInfo"]),

    },
    async mounted (){
        await this.getAIMap()
        await this.getMyTool()
        console.log(this.myTools);
        this.$bus.$emit('toolHandler', this.myTools[0].tool)
    },
    methods:{
        ...mapMutations(['setUserInfo']),
        // 展开收起
        handeleOpen(){
            this.leftIsReduce = !this.leftIsReduce
            const width = this.leftIsReduce ? '58px' : '179px'
            document.body.style.setProperty('--left-bar-width', width)
        },
        goLogin() {
            window.location.href = `${process.env.VUE_APP_BASE_URL}/cas/auth?redirectUri=${encodeURIComponent(
                window.location.href
            )}`;
        },
		loginOut() {
            window.location.href = `${process.env.VUE_APP_BASE_URL}/cas/logout?token=${window.localStorage.getItem('token')}`
            window.localStorage.removeItem("token")
			this.setUserInfo(null)
		},
        gotoMyPage(){
           this.$router.push('/my')
        },
        hideInfo(){
            this.infoTimer = setTimeout(()=>{
                this.showInfo = false
            },2000)
        },
        buyVip() {
            // this.$emit("openVip")
            //console.log(this.$route);
            if(this.$route.path != '/buyvip'){
                this.$router.push('/buyvip')
            }  
        },
        goOrder() {
            if (this.$route.path != '/myorder') {
                this.$router.push('/myorder')
            }
        },
        hideInfoHandeler() {
            clearTimeout(this.infoTimer)
            this.showInfo = false
        },
        showInfoHandeler(){
            clearTimeout(this.infoTimer)
            this.showInfo = true
        },
        async getAIMap(){
            let params = {
                token: window.localStorage.getItem("token"),
            };
            const {data} = await Api.getAIMapList(params)
            this.toolList.push(...data)
            console.log(this.toolList);
        },
        async getMyTool(){
            let params = {
                token: window.localStorage.getItem("token"),
            };
            const {data} = await Api.getMyTool(params)
            this.myTools.length = 0
            this.myTools.push(...data)
            console.log(this.myTools);
        },

        async toolCollect(item){
            if ( item.id == 1) return
            console.log(item);
            // 判断收藏取消收藏操作
            const _data = {
                token: window.localStorage.getItem("token"),
                tool_id: item.id
            }
            try{
                if (item.collect == 1) {
                    // 取消收藏
                    item.collect = 0
                    const {data} = await Api.delTool(_data)
                    Message.success('取消收藏成功');

                    console.log(data);
                }else{
                    // 添加收藏
                    item.collect = 1
                    const {data} = await Api.addTool(_data)
                    Message.success('添加收藏成功');
                    console.log(data);
                }
                await this.getMyTool()
            }catch(err){
                console.log(err);
                Message.error('操作失败');
            }
        },
        myToolClick(item){
            if (this.currentTool.id === item.tool.id) return
            // if(tool.name != 'AI聊天' && tool.name != 'PDF阅读助手') {
            if(item.tool.id != 1 && item.tool.id != 2) {
                return this.$message({
                    message: '场景暂未开放，敬请期待。',
                    type: 'warning',
                    center: true,
                    // duration:0
                });
            }
            this.currentTool = item.tool
            this.$bus.$emit('toolHandler', item.tool)
        },
        toolClick(tool){
            if (this.currentTool.id === tool.id) return
            // if(tool.name != 'AI聊天' && tool.name != 'PDF阅读助手') {
                if(tool.id != 1 && tool.id != 2) {
                return this.$message({
                    message: '场景暂未开放，敬请期待。',
                    type: 'warning',
                    center: true
                });
            }
            this.currentTool = tool
            this.$bus.$emit('toolHandler', tool)
            this.toolsPop = false
        },
        addChat(){
            this.$bus.$emit('addChat',this.currentTool.id)
        },  
        //展示侧边栏历史会话
        showSiderbar() {
            this.$emit("openSiderbar");
        },
    }
};
</script>

<style lang="scss" scoped>
.leftbar-box{
    @apply w-[358px] h-full relative flex-shrink-0;
    .leftbar-body {
        @apply w-full h-full px-8 pt-9 pb-14 flex flex-col border-r border-[#C2C4CB] relative pb-3;
        .reduce-btn{
            @apply px-[5px] cursor-pointer absolute top-2 right-7;
            img{
                @apply w-6 h-6;
            }
        }
        .header {
            // @apply h-14 max-sm:hidden flex flex-row items-center justify-end;
            @apply h-14 max-sm:hidden flex flex-row items-center justify-start mt-3;
            .free_user{
                background: url(@/assets/icon_free_pc.png) no-repeat;
                background-size: 100% auto;
                @apply w-[52px] h-[52px] cursor-pointer relative;
                .vip_info{
                    background: url(@/assets/youxiaoqi.png) no-repeat;
                    background-size: 100% auto;
                    // @apply w-[194px] h-[30px] pt-2 absolute top-[66px] left-[50%] ml-[-100px] hidden text-xs text-center text-[#7B5D41] z-20 block;
                    @apply w-[194px] h-[30px] pt-2 absolute top-[0] left-[50%] translate-x-[10%] translate-y-[-100%] ml-[-100px] hidden text-xs text-center text-[#7B5D41] z-20 block;
                }
                &:hover{
                    .vip_info{
                        @apply block;
                    }
                    .login_box{
                        @apply hidden;
                    }
                }
            }
            .vip_user{
                background: url(@/assets/icon_vip_pc.png) no-repeat;
                background-size: 100% auto;
            }
            .box1 {
                @apply relative w-[32px] h-[32px] rounded-full cursor-pointer;
                .avatar {
                    @apply w-full h-full rounded-full;
                }
                .login_box{
                    // @apply w-[158px] bg-white py-[20px] absolute top-[56px] right-0 px-[20px] rounded-[10px] z-10 text-sm;
                    @apply w-[158px] bg-white py-[20px] absolute top-[0] right-0 px-[20px] rounded-[10px] z-10 text-sm; transform: translate(75%, -110%);
                    box-shadow: 0px 4px 20px #D6D9E4;
                    &::before {
                        @apply absolute left-[25px] bottom-[-8px] translate-x-[-50%];
                        content: '';
                        border-top: 8px solid #fff;
                        border-left: 8px solid transparent;
                        border-right: 8px solid transparent;
                    }
                    &>p {
                        @apply leading-[25px] text-center mb-[15px];
                    }
                    &>div {
                        @apply pt-[15px] leading-[25px] text-[#000000] border-t border-[#C2C4CB];
                    }
                }
            }
        }
        .find-scene {
            @apply w-full pb-[30px] mb-[30px] border-b border-[#C2C4CB] cursor-pointer;
            .find-scene-body {
                @apply w-full h-14 cursor-pointer bg-[#444444] rounded-[15px];
                .find-scene-btn {
                    background: url(@/assets/scene_icon.png) no-repeat 16px center;
                    background-size: 34px 34px;
                    @apply w-full h-full border-none pl-[51px] text-white text-[16px] text-left;
                }
            }
        }
        .scene-list-box {
            @apply w-full h-full;
            .scene-item {
                @apply w-full h-14 px-4 cursor-pointer bg-white rounded-[15px] flex items-center justify-start mb-[6px];
                span{
                    margin-right: 1px;
                }
                .scene-icon {
                    @apply w-[34px] h-[34px];
                }
                .scene-name {
                    @apply text-[14px] text-[#333333];
                }
                &.active 
                {
                    @apply bg-[#4C5BDF];
                    .scene-name {
                        @apply text-white;
                    }
                    // &.icon-chat {
                    &.icon-1 {
                        .scene-icon {
                            background: url(@/assets/icon_ai_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }

                    // &.icon-pdf {
                    &.icon-2 {
                        .scene-icon {
                            background: url(@/assets/icon_pdf_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }
                    
                    // &.icon-summary {
                    &.icon-3 {
                        .scene-icon {
                            background: url(@/assets/icon_summary_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }
                    
                    // &.icon-content {
                    &.icon-6 {
                        .scene-icon {
                            background: url(@/assets/icon_content_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }
                    // &.icon-rewrite {
                    &.icon-7 {
                        .scene-icon {
                            background: url(@/assets/icon_rewrite_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }
                }
                // &.icon-chat {
                &.icon-1 {
                    .scene-icon {
                        background: url(@/assets/icon_ai.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
                // &.icon-pdf {
                &.icon-2 {
                    .scene-icon {
                        background: url(@/assets/icon_pdf.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
                // &.icon-summary {
                &.icon-3 {
                    .scene-icon {
                        background: url(@/assets/icon_summary.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
                // &.icon-content {
                &.icon-6 {
                    .scene-icon {
                        background: url(@/assets/icon_content.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
                // &.icon-rewrite {
                &.icon-7 {
                    .scene-icon {
                        background: url(@/assets/icon_rewrite.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
            }
        }
        .new-chat {
            @apply w-full h-14 px-4 bg-[#FAF9F9] sm:bg-white rounded-[15px] cursor-pointer mb-8;
            .new-chat-text {
                background: url(@/assets/icon_add_chat.png) no-repeat left 16px;
                background-size: 22px 22px;
                padding-left: 30px;
                border: none !important;
                @apply w-full text-left h-14 text-base leading-[36px] py-[10px] text-[#333333];
                &:hover{
                    color: #333333 !important;
                }
            }
        }
        .history-btn{
            @apply flex items-center;
            .history-icon{
                @apply w-[34px] h-[29px] px-[6px] py-[6px] mr-[10px] cursor-pointer rounded-[5px];
                background: url(@/assets/icon_open_sidebar.png) no-repeat center center white;
                background-size: 22px 17px;
            }
            p{
                @apply text-[14px] text-[#333333];
            }
        }
    }
}

.reduce-left-bar{
    @apply max-w-[58px] pl-[7px] h-full relative flex-shrink-0;
    .leftbar-body {
        @apply w-full h-full px-1 pt-9 pb-6 flex flex-col border-r border-[#C2C4CB] relative items-center justify-center;
        .enlarge-btn{
            @apply px-[5px] mb-2 cursor-pointer absolute top-2 right-3;
            img{
                @apply w-6 h-6;
            }
            .title-box{
                @apply hidden min-w-[80px] bg-[#E8EFFA] rounded-lg px-[6px] py-1 text-[#000000] text-[14px] leading-[20px] font-[500] whitespace-nowrap text-center;
                position: absolute;
                left: 50px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 1;
            }
            &:hover{
                .title-box{
                    @apply block;
                }
            }
        }
        .title-img{
            @apply relative;
            .title-box{
                @apply hidden min-w-[80px] bg-[#E8EFFA] rounded-lg px-[6px] py-1 text-[#000000] text-[14px] leading-[20px] font-[500] whitespace-nowrap text-center;
                position: absolute;
                left: 50px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 1;
            }
            &:hover{
                .title-box{
                    @apply block;
                }
            }
        }
        .new-chat {
            @apply w-[34px] h-[34px] px-[6px] py-[6px] bg-[#FAF9F9] sm:bg-white rounded-[5px] cursor-pointer mb-8;
            &:hover{
                @apply bg-[#E8EFFA];
            }
            .new-chat-text {
                width: 22px;
                height: 22px;
                background: url(@/assets/icon_add_chat.png) no-repeat center center;
                background-size: 22px 22px;
                border: none !important;
            }
        }
        .scene-list-box {
            @apply w-full h-full;
            .scene-item {
                @apply w-[34px] h-[34px] cursor-pointer bg-white rounded-[5px] flex items-center justify-start mb-[6px];
                &:hover{
                    @apply bg-[#E8EFFA];
                }
                span{
                    margin-right: 1px;
                }
                .scene-icon {
                    @apply w-[34px] h-[34px];
                }
                .scene-name {
                    @apply text-[14px] text-[#333333];
                }
                &.active 
                {
                    @apply bg-[#4C5BDF];
                    .scene-name {
                        @apply text-white;
                    }
                    // &.icon-chat {
                    &.icon-1 {
                        .scene-icon {
                            background: url(@/assets/icon_ai_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }

                    // &.icon-pdf {
                    &.icon-2 {
                        .scene-icon {
                            background: url(@/assets/icon_pdf_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }
                    
                    // &.icon-summary {
                    &.icon-3 {
                        .scene-icon {
                            background: url(@/assets/icon_summary_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }
                    
                    // &.icon-content {
                    &.icon-6 {
                        .scene-icon {
                            background: url(@/assets/icon_content_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }
                    // &.icon-rewrite {
                    &.icon-7 {
                        .scene-icon {
                            background: url(@/assets/icon_rewrite_c.png) no-repeat left center;
                            background-size: 34px 34px;
                        }
                    }
                }
                // &.icon-chat {
                &.icon-1 {
                    .scene-icon {
                        background: url(@/assets/icon_ai.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
                // &.icon-pdf {
                &.icon-2 {
                    .scene-icon {
                        background: url(@/assets/icon_pdf.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
                // &.icon-summary {
                &.icon-3 {
                    .scene-icon {
                        background: url(@/assets/icon_summary.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
                // &.icon-content {
                &.icon-6 {
                    .scene-icon {
                        background: url(@/assets/icon_content.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
                // &.icon-rewrite {
                &.icon-7 {
                    .scene-icon {
                        background: url(@/assets/icon_rewrite.png) no-repeat left center;
                        background-size: 34px 34px;
                    }
                }
            }
        }
        .history-btn{
            @apply flex items-center;
            .history-icon{
                @apply w-[34px] h-[29px] px-[6px] py-[6px] cursor-pointer rounded-[5px];
                background: url(@/assets/icon_open_sidebar.png) no-repeat center center white;
                background-size: 22px 17px;
                // background: red;
            }
        }
        .box1{
            @apply relative;
        }
        .login_box{
            // @apply w-[158px] bg-white py-[20px] absolute top-[56px] right-0 px-[20px] rounded-[10px] z-10 text-sm;
            @apply w-[158px] bg-white py-[20px] absolute bottom-0 right-0 px-[20px] rounded-[10px] z-10 text-sm; 
            transform: translate(100%, 0);
            box-shadow: 0px 4px 20px #D6D9E4;

            &>p {
                @apply leading-[25px] text-center mb-[15px];
            }
            &>div {
                @apply pt-[15px] leading-[25px] text-[#000000] border-t border-[#C2C4CB];
            }
        }
        .free_user{

            .vip_info{
                background: url(@/assets/youxiaoqi.png) no-repeat;
                background-size: 100% 30px;
                // @apply w-[194px] h-[30px] pt-2 absolute top-[66px] left-[50%] ml-[-100px] hidden text-xs text-center text-[#7B5D41] z-20 block;
                @apply w-[194px] h-[30px] pt-2 absolute top-[50%] right-0 translate-x-[100%] translate-y-[-50%] ml-[-100px] hidden text-xs text-center text-[#7B5D41] z-20 block;
            }
            &:hover{
                .vip_info{
                    @apply block;
                }
            }
        }
        .vip_user2{
            position: relative;
        }

    }
}


.more-scene-body{
    @apply bg-white rounded-[15px] pt-6 pb-1 px-5 relative z-0;

    .more-scene-cont{
        @apply  mb-7 pb-7 border-b border-[#C2C4CB];
        .list-title{
            @apply text-[16px] text-[#444444] font-bold leading-[22px];
        }
        .tool-list{
            @apply flex flex-row items-start flex-wrap justify-start;
            .tool-item{
                @apply w-[126px] h-9 mt-3 mr-5 bg-[#FAF9F9] rounded-[10px] text-sm leading-9 text-center cursor-pointer relative;
                &:nth-child(3n){
                    @apply mr-0;
                }

                .fixed-icon{
                    @apply w-[13px] h-[13px] absolute top-[3px] right-[3px] hidden;
                }
                
                &:hover{
                    @apply bg-[#F6F9FE] text-[#4C5BDF];
                    .fixed-icon{
                        display: block;
                        background: url(@/assets/fixed_icon0.png) no-repeat;
                        background-size: 100% auto;
                        &:hover{
                            background: url(@/assets/fixed_icon.png) no-repeat;
                            background-size: 100% auto;
                        }
                    }
                }
                &.collected{
                    @apply bg-[#F6F9FE] text-[#4C5BDF];
                    .fixed-icon{
                        display: block;
                        background: url(@/assets/fixed_icon.png) no-repeat;
                        background-size: 100% auto;
                    }
                }
                &.AIChat{
                    @apply bg-[#F6F9FE] text-[#4C5BDF];
                    .fixed-icon{
                        display: block;
                        background: url('@/assets/fixed_icon1.png') no-repeat;
                        background-size: 13px 13px;
                        &:hover{
                            background: url(@/assets/fixed_icon1.png) no-repeat;
                            background-size: 100% auto;
                        }
                    }
                }
            }
            &:last-child{
                border: none;
            }
        }
        &:last-child{
            border: none;
            margin-bottom: 0;
        }
    }
}
.vip_user2{
    width: 52px;
    height: 52px;
    background: url(@/assets/icon_vip_pc.png) no-repeat;
    background-size: 100% auto;
}
</style>